module.exports = __webpack_public_path__ + "img/botsetting.30e6d357.png";